// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsFundChartModule } from './app.module';
bootstrapAppModule(MutualFundsFundChartModule);
